module.exports = __webpack_public_path__ + "img/blog_27.96b6a5d1.jpeg";